import { getStorageItem } from "../helpers/utils";

export const formObject = {
  address: "",
  dob: "",
  email: "",
  gender: "",
  mobile: "",
  name: "",
  partnerId: getStorageItem("partnerId"),
  pan_number: "",
  captureFatherName: "",
  panRequired: "",
  declaration: true,
};

export const errorMessageObject = {
  address: "",
  dob: "",
  email: "",
  gender: "",
  mobile: "",
  name: "",
  pan_number: "",
};

export const touchFieldObject = {
  address: false,
  dob: false,
  email: false,
  gender: false,
  mobile: false,
  name: false,
};

export const accordianObject = {
  unfilled: true,
  filled: false,
};

export const autoCompleteObject = {
  code: "",
  label: "Select",
};
